"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var searchInputLocal = function searchInputLocal() {
  return {
    appearance: {
      primary: {
        closeIconAppearance: 'primary',
        searchIconAppearance: 'primary',
        inverseCloseIcon: false,
        inverseSearchIcon: false
      }
    }
  };
};
var _default = searchInputLocal;
exports["default"] = _default;